/**
 * Centralized environment variable configuration
 */

// Base URLs from environment
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const FRONTEND_BASE_URL = import.meta.env.VITE_FRONTEND_BASE_URL;
export const AGENT_CHAT_API_URL = import.meta.env.VITE_AGENT_CHAT_API_URL ?? "";
export const AGENT_CHAT_WIDGET_URL = import.meta.env.VITE_AGENT_CHAT_WIDGET_URL ?? "";
export const AGENT_CHAT_INSTALLATION_ID = import.meta.env.VITE_AGENT_CHAT_INSTALLATION_ID ?? "";

/** Build-time switch for the SuperGod Clarity UI. Read at call time so tests can toggle it. */
export const isClarityEnabled = (): boolean => import.meta.env.VITE_CLARITY_ENABLED === 'true';

// Auth endpoints
export const GOOGLE_AUTH_ENDPOINT = `${API_BASE_URL}/auth/google`;

// User profile URL builder
export const getUserProfileUrl = (slug: string | number): string => 
  `${FRONTEND_BASE_URL}/${slug}`;

// Environment checks
export const isDevelopment = import.meta.env.MODE === 'development';
export const isProduction = import.meta.env.MODE === 'production';
